export const flattenTextArray = (textArray, textKey) => {
  if (textArray.length === 1) return textArray[0];

  return textArray.reduce(
    (prev, current) =>
      `${prev} ${current[textKey] ? current[textKey] : current}`,
    '',
  );
};
